import { ProgressSpinner } from "primereact/progressspinner";
import React, { useContext } from "react";
import { AppContext } from "./components/Store";

export default function BlockUI() {
  const { showBlockUI } = useContext(AppContext);

  if (!showBlockUI) {
    return null;
  }

  return (
    <div className="block-ui">
      <ProgressSpinner />
    </div>
  );
}
